
ResourceCoordinator.registerVendor('Toastr', {
    urls:[    
    'https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.css',
    'https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.js',
    ],
    version: 'latest',
    
}
)

ResourceCoordinator.registerVendor('Mediabox', {
    urls:[
        'https://cdn.jsdelivr.net/npm/mediabox@1.1.3/dist/mediabox.min.css',
        'https://cdn.jsdelivr.net/npm/mediabox@1.1.3/dist/mediabox.min.js',
    ],
    version: 'latest',
    }
)

ResourceCoordinator.registerVendor('Beefup', {
    urls:[
        'https://cdn.jsdelivr.net/npm/beefup@1.1.7/dist/js/jquery.beefup.min.js',
    ],
    version: 'latest',
    }
)

ResourceCoordinator.registerVendor('JqueryDebounce', {
    urls:[
        'https://cdn.jsdelivr.net/npm/jquery-throttle-debounce@1.0.0/jquery.ba-throttle-debounce.min.js',
    ],
    version: 'latest',
    })

ResourceCoordinator.registerVendor('JModal', {
    urls:[
    'https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.css',
    'https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.js',
    ],
    version: 'latest',
    })


ResourceCoordinator.registerVendor('TippyDependency', {
    urls:[
    'https://unpkg.com/@popperjs/core@2',
    ],
    version: 'latest',
    }
  )

ResourceCoordinator.registerVendor('Yotpo', {
        urls:[
        'https://cdn-widgetsrepository.yotpo.com/v1/loader/l1yXdINmtGD3qNKciq34lRKOxhoQID5Dgywy1TDc?languageCode=en',
        ],
        version: 'latest',
    })

ResourceCoordinator.registerVendor('Select2', {
  urls: [
    'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css',
    'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js',
  ],
  version: '4.1.0-rc.0',
})

ResourceCoordinator.registerVendor('Swiper', {
  urls: [
    'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.css',
    'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.js',
  ],
  version: 'latest', // You might want to specify an exact version here
})


ResourceCoordinator.registerVendor('Splide', {
    urls: [
    'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.0.1/dist/css/splide.min.css',
    'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.0.1/dist/css/splide-core.min.css',
    'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.0.1/dist/css/themes/splide-default.min.css',
    'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.0.1/dist/js/splide.min.js',
  ],
    version: 'latest',
})

ResourceCoordinator.registerVendor('Tippy', {
  urls: [
    'https://cdn.jsdelivr.net/npm/tippy.js@6.3.7/dist/tippy.min.css',
    'https://cdn.jsdelivr.net/npm/tippy.js@6.3.7/dist/tippy.umd.min.js',
  ],
  version: '6.3.7',
})


ResourceCoordinator.registerVendor('Pikaday', {
  urls: [
    'https://cdn.jsdelivr.net/npm/pikaday@1.8.0/css/pikaday.min.css',
    'https://cdn.jsdelivr.net/npm/pikaday@1.8.0/pikaday.min.js',
  ],
  version: '1.8.0',
})

